import { Observable, ReplaySubject } from 'rxjs/Rx';
import { Headers, RequestOptions, URLSearchParams, ResponseContentType } from '@angular/http';

let cacheableCache: { [key: string]: Observable<any> } = {};
export function cacheable<T>(returnObservable: () => Observable<T>, key?: string, refresh?: boolean, customCache?: { [key: string]: Observable<T> }): Observable<T> {
  if (refresh)
    delete cacheableCache[key];
  if (!!key && (customCache || cacheableCache)[key]) {
    return (customCache || cacheableCache)[key] as Observable<T>;
  }
  let replay = new ReplaySubject<T>(1);
  returnObservable().subscribe(
    x => replay.next(x),
    x => replay.error(x),
    () => replay.complete()
  );
  let observable = replay.asObservable();
  if (!!key) {
    if (!!customCache) {
      customCache[key] = observable;
    } else {
      cacheableCache[key] = observable;
    }
  }
  return observable;
};

export function clearCache(key: string) {
  delete cacheableCache[key];
}
let defaultHeaders = new Headers({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
});

export function headers(filter: any = null) {
  let params: URLSearchParams = new URLSearchParams();
  if (filter != null) Object.keys(filter).map(k => params.set(k, filter[k]));

  let token = localStorage.getItem('token')

  if (token != null) {
    defaultHeaders.set('Authorization', `Bearer ${localStorage.getItem('token')}`)
  }

  return new RequestOptions({ headers: defaultHeaders, params: params });
}

export function headersBlob(filter: any = null) {
  let params: URLSearchParams = new URLSearchParams();
  if (filter != null) Object.keys(filter).map(k => params.set(k, filter[k]));

  let token = localStorage.getItem('token')

  if (token != null) {
    defaultHeaders.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
  }

  return new RequestOptions({ headers: defaultHeaders, responseType: ResponseContentType.Blob, params: params });
}


// WEBPACK FOOTER //
// ./src/app/util/rxjs-functions.ts